import { ICompany } from '@company/company.structures';
import { Subscription, Observable } from 'rxjs';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { IDialogData, IMember, IErrorResponse, ICompanyUser, IUser } from '@interfaces';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatSnackBar, MatSlideToggleChange } from '@angular/material';
import { DialogComponent } from '@dialog/dialog.component';
import { MemberService } from '@base/member/member.service';
import { CompanyUserService } from '@base/company-user/company-user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ExceptionService } from '@exceptions-service';
import { UserService } from '@user/user.service';
import { COMPANY, GROUP, UNDEFINED, EMPTY } from '@utils';
import { CompanyService } from '@base/company/company.service';

@Component({
  selector: 'app-dialog-popup-info',
  templateUrl: './dialog-popup-info.component.html',
  styleUrls: ['./dialog-popup-info.component.sass']
})
export class DialogPopupInfoComponent implements OnInit, OnDestroy {
  private _observable: Observable<any>;
  private _subscriptions: Subscription[];
  rows: object[];
  user: IUser;
  title = '';
  infoType = null;
  company = EMPTY;
  companies: ICompany[];

  p1 = 1;
  filterItems = '';

  constructor(
    public dialogRef: MatDialogRef<DialogPopupInfoComponent>,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private memberService: MemberService,
    private companyUserService: CompanyUserService,
    private exceptionService: ExceptionService,
    private userService: UserService,
    private companyService: CompanyService,
    @Inject(MAT_DIALOG_DATA) public info: [],
  ) {
    this._subscriptions = [];
    this.companies = [];
    this.rows = [];
    this.user = EMPTY;
    this.infoType = info['infoType'];

    if (this.infoType === COMPANY) {
      this.title = 'Empresas';
    } else if (this.infoType === GROUP) {
      this.title = 'Grupos';
    }

    // escuchar el cambio de usuario seleccionado para mostrar la info ...
    const userSelectedSubsription = this.userService.userSelectedChanged().subscribe((user: IUser) => {
      const auxUser = (typeof user !== UNDEFINED) ? user : EMPTY;
      this.user = auxUser;
      this.showUserInfo();
    });

    const companySubscription = this.companyService.observeCompanies().subscribe(
      (companies: ICompany[]) => this.companies = companies
    );
    this._subscriptions = [...this._subscriptions, userSelectedSubsription,
      companySubscription];
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this._subscriptions.map((subscription: Subscription) => subscription.unsubscribe());
    this.userService.setUser(EMPTY);
  }

  private showUserInfo() {
    let auxRows = [];

    if (this.infoType === COMPANY) {
      auxRows = this.user.companies;
    } else if (this.infoType === GROUP) {
      auxRows = this.user.memberships;
    }

    const finalRows = (auxRows.length > 0) ? auxRows.map((row: object) => {
      const item = (row.hasOwnProperty('company')) ? row['company'] : row['group'];
      return {
        id: row['id'],
        name: item['name'],
        desc: (item.hasOwnProperty('company')) ? item['company'] : null,
        status: row['active'],
      };
    }) : [];

    this.rows = finalRows;
  }

  openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 2000,
    });
  }

  deleteAllMemberships(companyId: number, rowId: number ) {
    let newMemberships = [];

    newMemberships = this.user.memberships
    .filter(item => {
      return item['group']['company_id'] !== companyId;
    })
    .filter((membership) => {
      const group: object = membership['group'];
      return group['company_id'] !== rowId;
    });

    this.user.memberships = newMemberships;
  }

  updateUserEntity(row: object) {
    // row es la empresa o el grupo que se desea eliminar...
    let objEntityIndex = -1;
    const rowId = row['id'];
    const auxRows = [...this.rows];
    const objRowIndex = auxRows.findIndex((obj => obj['id'] === rowId));

    if (this.infoType === COMPANY) {
      objEntityIndex = this.user.companies.findIndex((obj => obj['id'] === rowId));
    } else if (this.infoType === GROUP) {
      objEntityIndex = this.user.memberships.findIndex((obj => obj['id'] === rowId));
    }

    if (objEntityIndex >= 0) {
      let deleted = null;

      if (this.infoType === COMPANY) {
        // borrar las membresias del usuario en los grupos de la empresa que se esta eliminando
        const companyDetails: ICompany = this.user.companies[objEntityIndex]['company'];
        this.deleteAllMemberships(companyDetails.id, parseInt(row['id'], 10));

        // actualizar la lista de empresas a las que esta asociado
        deleted = this.user.companies.splice(objEntityIndex, 1);
      }
      if (this.infoType === GROUP) {deleted = this.user.memberships.splice(objEntityIndex, 1); }
    }

    // lo elimina de la lista del popup
    if (objRowIndex >= 0) {
      const deleted = auxRows.splice(objRowIndex, 1);
    }

    // actualiza el store de usuarios...
    this.userService.updateUser(this.user);

    this.rows = auxRows;
    if (this.rows.length === 0) {
      this.dialog.closeAll();
    }
  }

  private updateState(objectInfo, action = 'remove') {
    if (typeof objectInfo === 'undefined') {
      return true;
    }

    if (this.infoType === COMPANY) {
      const auxCompanies = [...this.companies];
      const selectedCompany = auxCompanies.find(c => c.id === objectInfo['id']);
      const objIndex = selectedCompany.users.findIndex((u) => u['user']['id'] === this.user.id);

      if (objIndex >= 0) {
        if (action === 'remove') {
          const removed = selectedCompany.users.splice(objIndex, 1);
        } else if (action === 'update') {
          selectedCompany.users[objIndex].active = objectInfo['status'];
        }

        this.companyService.updateState(selectedCompany);
      }
    }
  }

  popupDelete(row: object) {
    const strMessage = `¿Desea borrar a ${this.user.first_name} ${this.user.last_name} de ${row['name']}?`;
    const params: IDialogData = {
      strQuestion: strMessage,
      strAccept: 'Aceptar',
      strCancel: 'Cancelar',
      buttonColor: 'warn',
    };
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '370px',
      data: params,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((deleteObject) => {
      if (deleteObject) {
        let _subscription: Subscription = null;
        const rowName = row['name'];
        const auxUser = {...this.user};
        const auxCompanies = [...auxUser.companies];
        const auxMemberships = [...auxUser.memberships];

        if (this.infoType === COMPANY) {
          const company = auxCompanies.filter(item => item['company']['name'] === rowName)[0];
          const companyId = company['company']['id'];
          const companyUser: ICompanyUser = {
            id: row['id'],
            active: false,
            company_id: companyId,
            user_id: this.user.id,
            user: this.user,
          };
          this.company = company['company'];
          this._observable = this.companyUserService.delete(companyUser);
        } else if (this.infoType === GROUP) {
          const groupId = auxMemberships.filter(item => item['group']['name'] === rowName)[0]['group']['id'];
          const membership: IMember = {
            id: row['id'],
            active: false,
            group_id: groupId,
            user: this.user
          };
          this._observable = this.memberService.delete(membership);
        }

        this.updateUserEntity(row);
        _subscription = this._observable.subscribe(
          (response) => {
            const obj = this.company;
            this.updateState(obj);
            _subscription.unsubscribe();
            this.openSnackBar(`${rowName} se elimino de la plataforma`, 'info');
          },
          (err: HttpErrorResponse) => {
            const error: IErrorResponse = this.exceptionService.errorHandling(err);
            this.openSnackBar(error.message, error.title);
          }
        );
      }
    });
  }

  updateStatus(event: MatSlideToggleChange, row: object) {
    const rowName = row['name'];
    let _subscription: Subscription = null;
    this._observable = EMPTY;

    if (typeof row['id'] !== 'undefined') {
      if (this.infoType === COMPANY) {
        const _company = this.user.companies.filter(item => item['company']['name'] === rowName)[0]['company'];
        const companyuser: ICompanyUser = {
          id: row['id'],
          active: event.checked,
          user_id: this.user.id,
          company_id: _company['id'],
          user: this.user,
        };
        this._observable = this.companyUserService.switchStatus(companyuser);
      } else if (this.infoType === GROUP) {
        const groupId = this.user.memberships.filter(item => item['group']['name'] === rowName)[0]['group']['id'];
        const membership: IMember = {
          id: row['id'],
          active: event.checked,
          group_id: groupId,
          user: this.user,
        };

        this._observable = this.memberService.switchStatus(membership);
      }
    }

    if (this._observable !== null) {
      _subscription = this._observable.subscribe(
        response => {
          _subscription.unsubscribe();

          if (this.infoType === COMPANY) {
            const obj = {
              id: response['company'],
              status: response['active'],
            };
            this.updateState(obj, 'update');
          } else if (this.infoType === GROUP) {
            //
          }
        },
        err => console.log(err)
      );
    }
  }
}
